import { palette } from '@livable/saas-react-components';
const MuiList = {
  styleOverrides: {
    root: {}
  },
  variants: [{
    props: {
      variant: 'classic'
    },
    style: {
      backgroundColor: palette.shades[100],
      padding: '24px',
      '& .MuiCheckbox-root': {
        padding: '0',
        width: '24px',
        height: '24px',
        marginRight: '8px'
      },
      '& .MuiListItemButton-root': {
        paddingTop: '6px',
        paddingBottom: '6px'
      }
    }
  }, {
    props: {
      variant: 'white'
    },
    style: {
      backgroundColor: palette.shades[100],
      padding: '0',
      borderRadius: '2px',
      border: "1px solid ".concat(palette.shades[300]),
      '& .iconWrapper': {
        marginRight: '20px'
      },
      '& .MuiListItem-root': {
        padding: '18px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      },
      '.MuiListItem-root + .MuiListItem-root': {
        borderTop: "1px solid ".concat(palette.shades[300])
      },
      '+ .MuiList-root': {
        marginTop: '20px'
      }
    }
  }]
};
export default MuiList;